import { useEffect, useState } from 'react';
import { SEARCH_DEBOUNCE_MS } from './constants';

const useDebouncedSearch = (search, delay = SEARCH_DEBOUNCE_MS) => {
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const q = (search || '').trim();
    if (!q) {
      setDebouncedSearch('');
      return undefined;
    }
    const timer = setTimeout(() => setDebouncedSearch(q), delay);
    return () => clearTimeout(timer);
  }, [search, delay]);

  return [debouncedSearch, setDebouncedSearch];
};

export default useDebouncedSearch;
